import { render, staticRenderFns } from "./projectForm.vue?vue&type=template&id=3645ce1a"
import script from "./projectForm.vue?vue&type=script&lang=js"
export * from "./projectForm.vue?vue&type=script&lang=js"
import style0 from "./projectForm.vue?vue&type=style&index=0&id=3645ce1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports